/**
 * @generated SignedSource<<7f6115d04710610a1e60a5b033228423>>
 * @relayHash debf86387836a4b06c9090ec7c9457e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 857e7ac302ce3bf801ab2c122600f97cb99c58f4ac806b5368cc23a1f0e7ea3d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SupportWebsiteOverviewQuery } from './SupportWebsiteOverviewQuery.graphql';

const node: PreloadableConcreteRequest<SupportWebsiteOverviewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "857e7ac302ce3bf801ab2c122600f97cb99c58f4ac806b5368cc23a1f0e7ea3d",
    "metadata": {},
    "name": "SupportWebsiteOverviewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
